import { Dropdown, MenuProps, Select, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
// import SigningDocument from './_SigningDocument';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import SueItemUpdate from './_SueItemUpdate';

type Props = {
    customerId: string;
    tabData: any;
    config: any;
    setLoading: Function;
    updateEditData: Function;
    updatePolicy: Function;
    onFileDelete: Function;
    onRelaodAfterSaveSue: Function;
    updateMode: Function;
    addSigningComment: Function;
};

// 
const SueDetails = (props: Props) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [sueData, setSueData] = useState<any>({});
    const [customer, setCustomer] = useState<any | null>(null);
    const [driver, setDriver] = useState<any | null>(null);
    const [customerPhone, setCustomerPhone] = useState<any | null>(null)
    const [customerAdditionalPhone, setCustomerAdditionalPhone] = useState<any | null>(null)
    const [gender, setGender] = useState<string>('');
    const [address, setAddress] = useState<any>({});
    const [documentsList, setDocumentsList] = useState<any[]>([]);
    const [policyNumber, setPolicyNumber] = useState<string>('');
    const [policyTypeId, setPolicyTypeId] = useState<number>(0);

    const [sueHandlerName, setSueHandlerName] = useState<string>('')

    const [sueInternalNumber, setSueInternalNumber] = useState<string>('')

    const [openingDate, setOpeningDate] = useState<Date | null>(null);
    const [closingDate, setClosingDate] = useState<Date | null>(null);
    const [paymentDate, setPaymentDate] = useState<Date | null>(null);

    const [dataToUpdate, setDataToUpdate] = useState<any | null>();
    
    const [status, setStatus] = useState<string>('');
    const [statusId, setStatusId] = useState<string>('0');

    const [showDocumentsList, setShowDocumentsList] = useState<boolean>(true);

    const [driversType, setDriversType] = useState<string>('')
    const [vehicleOwnership, setVehicleOwnership] = useState<string>('');


    const [selectedDocument, setSelectedDocument] = useState<any | null>(null);

    const init = (sueItemData: any) => {
        console.log('SueDetails sueData', sueItemData);
        const dataForUpdate = {
            "sueNumber": sueItemData.sueNumber,
            "policyId": sueItemData.policyId,
            "serialNumber": sueItemData.serialNumber,
            "internalNumber": sueItemData.internalNumber,
            "openingDate": sueItemData.openingDate,
            "closingDate": sueItemData.closingDate,
            "sueType": sueItemData.sueType,
            "status": sueItemData.status,
            "activityStatus": sueItemData.activityStatus,
            "riderId": sueItemData.riderId,
            "customerId": sueItemData.customerId,
            "handlerId": sueItemData.handlerId,
            "insuranceCompanyId": sueItemData.insuranceCompanyId,        
            "damageAppraiser": sueItemData.damageAppraiser,
            "impairment": sueItemData.impairment,
            "deductible": sueItemData.deductible,
            "impairmentPercent": sueItemData.impairmentPercent,
            "appraiserAmount": sueItemData.appraiserAmount,
            "establishmentValue": sueItemData.approvedAmount,
            "additionalExpenses": sueItemData.approvedAmount,
            "requestedAmount": sueItemData.approvedAmount,
            "approvedAmount": sueItemData.approvedAmount,
            "paymentDate": sueItemData.paymentDate,
            "comments": sueItemData.comments,
            "vehicleId": sueItemData.vehicleId,
            "driverId": sueItemData.driverId,
            "seniorityDate": sueItemData.seniorityDate,
            "sueAccidentAndDamageInfo": sueItemData.sueAccidentAndDamageInfo,
            "involvedVehiclesList": sueItemData.involvedVehiclesList,
            "branchId": sueItemData.branchId,
            "customerCheckMaturityDate": sueItemData.customerCheckMaturityDate,
            "documents": sueItemData.documents,
            "treatments": sueItemData.treatments,
            "sueComments": sueItemData.sueComments,
            "createdDate": sueItemData.createdDate,
            "updatedDate": sueItemData.updatedDate
        };
        setDataToUpdate(dataForUpdate);
        setOpeningDate(sueItemData.openingDate);
        setClosingDate(sueItemData.closingDate)
        setSueData(dataForUpdate);

        if(sueItemData.handler) {
            setSueHandlerName(sueItemData.handler.fullName);
        }

        if (sueItemData.driver) {
            setDriver(sueItemData.driver);
        }
    }
    
    const onUpdate = (newData: any) => {
        if(props.updateEditData ) {
            props.updateEditData(newData)
        }
    }

    
    const addSigningComment = (comment: string)=> {
        if (props.addSigningComment) {
            const data = {    
                "TreatmentType": 4,
                "AlertDate": moment().format('YYYY-MM-DDTHH:mm'),
                "Topic": comment,
                "PolicyRelatedId": sueData.policy.id,
                'Seen':true
            }
            props.addSigningComment(data);
        }
    }

    const onSelectDocument = (document: any) => {
        setSelectedDocument(document);
    }

    const onCloseDocument = () => {
        setSelectedDocument(null);
    }

    const handleFileChange = async (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string =((fileUploaded.size/1024)/1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            await setShowDocumentsList(false)
            reader.onloadend = async() => {
                const data = sueData.elementaryPolicy;
                const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                if (!data.fileAttachments) {
                    data.fileAttachments = [];
                }
                data.fileAttachments.push(
                    {
                        FileName: fileName,
                        Content: reader.result
                    }
                );
                if(props.updatePolicy) {
                    props.updatePolicy(data);
                }
                
                const documents = documentsList;
                
                await setDocumentsList([]);
                documents.push ({
                    filePath: fileName,
                    fileSize: 0,
                    user: null,
                    createdDate: moment(),
                    isDeleted: false,
                    isAttachment: true
                })
                await setDocumentsList(documents);
                await setShowDocumentsList(true);
                const comment = `נוסף קובץ בשם: ${fileName}`;
                addSigningComment(comment);
            }
            reader.readAsDataURL(fileUploaded);
        }
    };
    
    const handleButtonClick = () => {
        // Programmatically click the hidden file input
        if (fileInputRef.current) {
        fileInputRef.current.click();
        }
    };

    
    const onDateChange = async (name: string, date: Date)=> {
        console.log('onDateChange', date);
        const sueCurrentData = sueData;
        switch (name) {
            case 'openingDate':
                if(moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    sueCurrentData.openingDate = date;
                    setOpeningDate(date);
                } else {
                    sueCurrentData.openingDate = undefined;
                    setOpeningDate(null);
                }
                break;
            case 'closingDate':
                if(moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setClosingDate(date);
                    sueCurrentData.closingDate = date;
                } else {
                    sueCurrentData.closingDate = undefined;
                    setClosingDate(null)
                }
                break;
            
            case 'paymentDate':
                if(moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setPaymentDate(date);
                    sueCurrentData.paymentDate = date;
                } else {
                    sueCurrentData.paymentDate = undefined;
                    setPaymentDate(null)
                }
                break;
            default:
                break;
        }
        await setSueData(sueCurrentData);
    }

    const onFileDelete = async (file: any, index: number) => {
        await setShowDocumentsList(false)
        if (file.isAttachment) {

        } else {
            if(props.onFileDelete) {
                props.onFileDelete(file.id);
            }
        }
        const documents = documentsList;
        documents.splice(index, 1);
        await setDocumentsList(documents);
        await setShowDocumentsList(true)
    }
    
    const onSaveClick = () =>{
        props.onRelaodAfterSaveSue(sueData)
    }

    useEffect(()=>{
        if (props.tabData) {
            // setItemData(props.tabData);
            const sueData = props.tabData.sueData;
            setSueData(sueData);

            console.log('SueDetails', props.tabData);
            const policyData = sueData.policy;
            const vehicleData = sueData.vehicle;
            const customerData = sueData.customer;
            const ownerCustomer = sueData.customer;if (ownerCustomer && ownerCustomer.customerContactDetails && ownerCustomer.customerContactDetails.length > 0) {
                setCustomerPhone(ownerCustomer.customerContactDetails[0].number);
                if (ownerCustomer.customerContactDetails[1]) {
                    
                    setCustomerAdditionalPhone(ownerCustomer.customerContactDetails[1].number);
                } else {
                    setCustomerAdditionalPhone('');
                }
            } else {
                setCustomerPhone('');
                setCustomerAdditionalPhone('');
            }
            const gendersList = props.tabData.genders;
            if (customerData && customerData.gender) {
                const selectedGender = gendersList.find((g: any)=>g.value == customerData.gender);
                if (selectedGender) {
                    setGender(selectedGender.label);
                }
            }
            if (customerData && customerData.customerAddresses && customerData.customerAddresses.length > 0) {
                setAddress(customerData.customerAddresses[0]);
            }
            
            if (vehicleData) {
                const selectedOwnership = props.tabData.vehicleOwnerships.find((vo: any) => vo.id === vehicleData.vehicleOwnership);
                if (selectedOwnership) {
                    setVehicleOwnership(selectedOwnership.name);
                }
            }
            setCustomer(ownerCustomer);
            if (policyData) {
                setPolicyNumber(sueData.policy.policyNumber);
                // setPolicyTypeId(sueData.policy.policyType.policyTypeId);
                setPolicyTypeId(1);
                
            }
            if (sueData.elementaryPolicyStatusId) {
                setStatusId(sueData.elementaryPolicyStatusId);
                const selectedStatus = props.tabData.statuses.find((s: any) => s.value === sueData.elementaryPolicyStatusId);
                if (selectedStatus) {
                    setStatus(selectedStatus.label)
                }
            }
            
            if (sueData.elementaryPolicy && sueData.elementaryPolicy.elementaryPolicyDocuments && sueData.elementaryPolicy.elementaryPolicyDocuments.length > 0) {
                setDocumentsList(sueData.elementaryPolicy.elementaryPolicyDocuments);
            }

            switch (sueData.driversType) {
                case 0:
                    setDriversType('נהג אחד')
                    break;
                case 1:
                    setDriversType('שני נהגים')
                    break;
                case 2:
                    setDriversType('כל נהג')
                    break;
            
                default:
                    break;
            }
            
            setSueInternalNumber(sueData.internalNumber);

            init(sueData);
        }
    }, [])
   

    return (
        <div className="content-body sue-details sue-details-view sue-details-view-mode">
            
            <SueItemUpdate
                    onRelaodAfterSaveSue={(data: any)=>{
                        props.onRelaodAfterSaveSue(data)
                    }}
                    customerId={props.customerId}
                    tabData={props.tabData}
                    setLoading={props.setLoading}
                    config={props.config} />
           
        </div>
    )
}
export default SueDetails;